import { useNotification } from '@/containers'
import { IconZalo } from '../Icon/IconZalo'

const NotificationBar = ({ className = '' }: { className?: string }) => {
  const { systemConfig } = useNotification()

  //   const isBrowser = () => typeof window !== 'undefined'
  //   const goTop = () => {
  //     if (!isBrowser()) return
  //     window.scrollTo({
  //       top: 0,
  //       behavior: 'smooth',
  //     })
  //   }
  return (
    <div
      className={`${className} fixed bottom-3 right-2 z-[9919] flex h-auto w-[70px] flex-col items-center justify-center text-mainBody transition-all duration-200 ease-in-out`}
    >
      <div className='flex w-full cursor-pointer flex-col items-center justify-center rounded-full py-1.5 text-center'>
        <a
          href={`${systemConfig?.companyMessenger || ''}`}
          target='_blank'
          rel='noreferrer'
        >
          <svg
            width='50'
            height='51'
            viewBox='0 0 50 51'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g clipPath='url(#clip0_19383_31558)'>
              <path
                d='M25 0.129862C11.4901 -0.136519 0.310907 10.5769 0.00244141 24.0858C0.0376919 30.9624 3.08261 37.4788 8.33493 41.9174V49.0834C8.33493 49.6586 8.80129 50.125 9.37653 50.125C9.57172 50.125 9.76301 50.0701 9.92852 49.9667L15.7342 46.34C18.6921 47.4713 21.8331 48.0482 25 48.0419C38.5099 48.3083 49.6891 37.5949 49.9976 24.0859C49.6891 10.5769 38.5099 -0.136519 25 0.129862Z'
                fill='#2196F3'
              />
              <path
                d='M41.4568 17.2115C41.1469 16.7961 40.5786 16.6718 40.1236 16.9198L29.2914 22.8255L22.5525 17.0469C22.1392 16.6926 21.5229 16.7161 21.1381 17.101L8.63928 29.5998C8.23376 30.0078 8.23571 30.6673 8.64377 31.0728C8.97001 31.3971 9.47026 31.469 9.87461 31.2497L20.7069 25.344L27.452 31.1247C27.8652 31.4789 28.4816 31.4554 28.8664 31.0705L41.3652 18.5717C41.7294 18.2041 41.7685 17.6247 41.4568 17.2115Z'
                fill='#FAFAFA'
              />
            </g>
            <defs>
              <clipPath id='clip0_19383_31558'>
                <rect
                  width='50'
                  height='50'
                  fill='white'
                  transform='translate(0 0.125)'
                />
              </clipPath>
            </defs>
          </svg>
        </a>
      </div>
      <div className='flex w-12 cursor-pointer flex-col items-center justify-center overflow-hidden rounded-full py-1.5 text-center'>
        <a
          href={`${systemConfig?.companyZalo || ''}`}
          target='_blank'
          rel='noreferrer'
        >
          <IconZalo
            className={
              'h-[50px] w-[50px] overflow-hidden rounded-full object-cover '
            }
          />
        </a>
      </div>
      {/* <div
        onClick={() => goTop()}
        className='flex w-full cursor-pointer flex-col items-center justify-center py-2.5 text-center'
      >
        <ArrowUp />
      </div> */}
    </div>
  )
}
export default NotificationBar
